import React from "react";
import {
  Button,
  Form,
  Row,
  Col,
  Spinner,
  FloatingLabel,
  Container,
} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { StorageServices, UserServices } from "../../../services";
import "./Login.css";
import { FormattedMessage } from "react-intl";
import { LanguageContext } from "../../../../contexts/LanguageContext";
import { Tools } from "../../../misc";

const secretCode = [
  "ArrowUp",
  "ArrowUp",
  "ArrowDown",
  "ArrowDown",
  "ArrowRight",
  "ArrowRight",
  "ArrowLeft",
  "ArrowLeft",
];

export default class Login extends React.Component<any, any> {
  static contextType = LanguageContext;

  constructor(props: any) {
    super(props);

    this.state = {
      isLoading: false,
      LoginFailed: false,
      isUserInvalid: false,
      isPasswordInvalid: false,
      isDropdownOpen: false,
      showSecretInput: false,
      keySequence: [],
      lastKeyTime: 0,
    };
  }

  componentDidMount() {
    document.addEventListener("keydown", this.handleKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown);
  }

  handleKeyDown = (event: KeyboardEvent) => {
    const currentTime = new Date().getTime();
    if (currentTime - this.state.lastKeyTime > 3000) {
      this.setState({ keySequence: [] });
    }

    this.setState(
      (prevState: any) => ({
        keySequence: [...prevState.keySequence, event.key],
        lastKeyTime: currentTime,
      }),
      () => {
        if (this.state.keySequence.toString().includes(secretCode.toString())) {
          this.setState({ showSecretInput: true, keySequence: [] });
        }
      }
    );

    if (event.key === "Enter") {
      this.onClickLogin();
    }
  };

  async onClickLogin() {
    try {
      if (this.state.userName && this.state.userPassword) {
        this.setState({ isLoading: true });

        const LoginValid = await UserServices.Login(
          this.state.userName,
          this.state.userPassword
        );

        this.setState({ isLoading: false });

        if (LoginValid && LoginValid.Status === 200) {
          StorageServices.SetCookieUser(LoginValid.Content);

          // Extraer culturelocale y hacer update del lenguaje del contexto
          const cultureLocale = LoginValid.Content.CultureLocale || "es-ES";
          const languageCode = cultureLocale.split("-")[0];
          this.context.changeLanguage(languageCode);

          if (Tools.IsDevelopment()) {
            console.log("login", LoginValid.Content);
            console.log("Login successful with culture locale:", cultureLocale);
          }

          // Trigger any additional success behaviors
          this.props.onSuccess();
        } else {
          // Handle failed login
          this.setState({
            LoginFailed: true,
            isUserInvalid: true,
            isPasswordInvalid: true,
          });
        }
      } else {
        // Validate input fields
        if (!this.state.userName) this.setState({ isUserInvalid: true });
        if (!this.state.userPassword)
          this.setState({ isPasswordInvalid: true });
      }
    } catch (error) {
      console.error("Login error:", error);
      this.setState({ isLoading: false });
    }
  }

  handlerInputChange(e: any) {
    this.setState({
      [e.target.name]: e.target.value,
      LoginFailed: false,
      isUserInvalid: false,
      isPasswordInvalid: false,
    });
  }

  render() {
    const { readysizelocale, changeLanguage } = this.context;
    return (
      <Container fluid className="h-100 login-main-card">
        <Row className="h-100">
          <Col
            xs={8}
            className="h-100 login-left-side-container"
            style={{ background: "rgba(254, 164, 66, 0.14)" }}
          >
            <Row className="align-items-start my-5 login-logo-container">
              <Col className="ps-5">
                <img
                  src="img/readysizelogo.png"
                  alt="Logo ReadySize"
                  width={244}
                />
              </Col>
            </Row>
            <Row className="align-items-center my-5 login-title-container">
              <Col className="ps-5">
                <h5 className="login-title-left">
                  <FormattedMessage id={"login-header"} />
                </h5>
              </Col>
            </Row>
            <Row
              className="align-items-end login-image-container"
              style={{ marginTop: "12%" }}
            >
              <Col className="text-center">
                <img
                  src="img/login-img.png"
                  alt="Login People"
                  width={810}
                  className="login-image-people"
                />
              </Col>
            </Row>
          </Col>
          <Col xs={4} className=" login-right-side-container">
            <div className="fitprenda-modal-close-lang-container-login">
              <div className="new-custom-dropdown">
                <div
                  className="new-selected-language"
                  onClick={() =>
                    this.setState({
                      isDropdownOpen: !this.state.isDropdownOpen,
                    })
                  }
                >
                  {readysizelocale === "en" && (
                    <img
                      src="/img/US.png"
                      alt="gb-lang"
                      className="new-readysize-flag-img"
                    />
                  )}
                  {readysizelocale === "es" && (
                    <img
                      src="/img/ES.png"
                      alt="es-lang"
                      className="new-readysize-flag-img"
                    />
                  )}
                  {readysizelocale === "pt" && (
                    <img
                      src="/img/BR.png"
                      alt="br-lang"
                      className="new-readysize-flag-img"
                    />
                  )}
                </div>
                {this.state.isDropdownOpen && (
                  <div className="new-dropdown-options">
                    <div onClick={() => changeLanguage("en")}>English</div>
                    <div onClick={() => changeLanguage("es")}>Español</div>
                    <div onClick={() => changeLanguage("pt")}>Português</div>
                  </div>
                )}
              </div>
            </div>
            <div className="login-rightside-container">
              <Form>
                <Form.Group as={Row} className="mb-3 justify-content-center">
                  <Col sm="10">
                    <h5 className="login-title-mail">Login</h5>
                    <h6 className="login-title-mail-sub">Mail</h6>
                    <FloatingLabel label="Email">
                      <Form.Control
                        size="sm"
                        type="text"
                        placeholder="usuario"
                        autoFocus={true}
                        name="userName"
                        onChange={(e) => this.handlerInputChange(e)}
                        isInvalid={this.state.isUserInvalid}
                      />
                    </FloatingLabel>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-3 justify-content-center">
                  <Col sm="10">
                    <h6 className="login-title-mail-sub">
                      <FormattedMessage id={"login-password-input-title"} />
                    </h6>
                    <FloatingLabel label="Password">
                      <Form.Control
                        size="sm"
                        type="password"
                        placeholder="password"
                        name="userPassword"
                        onChange={(e) => this.handlerInputChange(e)}
                        isInvalid={this.state.isPasswordInvalid}
                      />
                    </FloatingLabel>
                  </Col>
                </Form.Group>
                {this.state.showSecretInput && (
                  <Form.Group as={Row} className="mb-3 justify-content-center">
                    <Col sm="10">
                      <FloatingLabel label="Secret Input">
                        <Form.Control
                          size="sm"
                          type="text"
                          placeholder="Secret"
                          name="secretInput"
                        />
                      </FloatingLabel>
                    </Col>
                  </Form.Group>
                )}
              </Form>
              <Row className="justify-content-center">
                <Col sm="10">
                  <div className="d-grip gap-2">
                    <Button
                      className="login-btn"
                      type="button"
                      variant={
                        this.state.isLoading
                          ? "warning"
                          : this.state.LoginFailed
                          ? "danger"
                          : "warning"
                      }
                      size="sm"
                      onClick={() => this.onClickLogin()}
                    >
                      <div className="login-ingresar">
                        <FormattedMessage id={"login-button"} />
                      </div>
                      {this.state.isLoading ? (
                        <Spinner variant="light" animation="border" size="sm" />
                      ) : this.state.LoginFailed ? (
                        <FontAwesomeIcon
                          icon="ban"
                          size="lg"
                          className="text-light"
                        />
                      ) : (
                        <FontAwesomeIcon
                          icon="unlock"
                          size="lg"
                          className="text-light"
                        />
                      )}
                    </Button>
                    <div className="login-not-registered">
                      <p className="login-not-registered-p">
                        <FormattedMessage id={"login-no-account"} />{" "}
                        <span className="login-not-registered-p-span">
                          <a
                            className="login-not-registered-p-span"
                            href="https://readysize.ai/#form"
                          >
                            <FormattedMessage id={"login-contact-us"} />
                          </a>
                        </span>
                      </p>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Container>
    );
  }
}
